const initialState = {
  workflowFormsDetailsData: null,
};

/* ACTIONS */
const WORKFLOW_FORMS_DETAILS_DATA = "app/workflows/WORKFLOW_FORMS_DETAILS_DATA";
const CLEAR_WORKFLOW_FORMS_DATA = "app/workflows/CLEAR_WORKFLOW_FORMS_DATA";

type Action =
  | {
      type: typeof WORKFLOW_FORMS_DETAILS_DATA;
      payload: any;
    }
  | {
      type: typeof CLEAR_WORKFLOW_FORMS_DATA;
    };

/* REDUCER */
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case WORKFLOW_FORMS_DETAILS_DATA:
      return {
        ...state,
        workflowFormsDetailsData: action.payload,
      };

    case CLEAR_WORKFLOW_FORMS_DATA:
      return {
        ...state,
        workflowFormsDetailsData: null,
      };

    default:
      return state;
  }
}

/* ACTION CREATORS */

export const setWorkflowFormsDetailsData = (payload: any): Action => ({
  type: WORKFLOW_FORMS_DETAILS_DATA,
  payload: payload,
});

export const clearWorkflowFormsDetailsData = (): Action => ({
  type: CLEAR_WORKFLOW_FORMS_DATA,
});

/* SELECTORS */
export const selectWorkflowFormsDetailsData = (app: any) =>
  app.workflows.workflowFormsDetailsData;
